import { jwtDecode } from "jwt-decode";

// Función para decodificar JWT sin librerías externas
/*const jwtDecodeManual = (token) => {
  if (typeof token !== 'string') {
    throw new Error('Invalid token specified: must be a string.');
  }
  const parts = token.split('.');
  if (parts.length !== 3) {
    throw new Error('Invalid token specified: not a JWT.');
  }
  const base64Url = parts[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const decodedPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(decodedPayload);
};*/

export default function decodeTokenJWT(token) {
  try {
    const decoded = jwtDecode(token);
    // console.log("token decoded libreria ", jwtDecode(token))
    return decoded;
  } catch (error) {
    console.error("Error al decodificar el token:", error);
    return null;
  }
}